import manifestsReducer from "./manifestsSlice";
import manifestReducer from "./manifestSlice";

const manifests = {
  manifests: manifestsReducer,
  manifest: manifestReducer,
};

export default manifests;
